export const worksList = [
  {
    id: "work-1",
    type: "work",
    title: "星轨彼端",
    summary:
      "一名少女在老旧的星空观测站里发现了会“回应”愿望的星轨，由此踏上寻找失落星图的旅程。宏大的宇宙设定与细腻的人物成长是本作最大的看点。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20young%20girl%20astronomer%20standing%20in%20an%20observatory%20dome%20under%20a%20glowing%20starry%20sky%2C%20deep%20blue%20and%20gold%20palette%2C%20epic%20vertical%20key%20visual&width=600&height=800&seq=work-01&orientation=portrait",
    category: "科幻",
    tags: ["星轨彼端", "宇宙", "成长", "科幻"],
    date: "2024-07-15",
    author: "原案：苍井树",
    popularity: 96,
    format: "动画",
    region: "日本",
    year: "2024",
    rating: 9.1,
    sections: [
      {
        id: "s1",
        heading: "剧情简介",
        paragraphs: [
          "《星轨彼端》讲述少女弦月接手祖父留下的老旧观测站，并在那里发现了一种能够回应愿望的神秘星轨。为了解开星轨背后的秘密，她与伙伴们一同踏上寻找失落星图的旅程。",
          "作品以宇宙为舞台，却在宏大的设定之下始终关注人物内心的选择与成长，科幻外壳包裹着温柔的情感内核。",
        ],
      },
      {
        id: "s2",
        heading: "主要角色",
        paragraphs: [
          "主角弦月性格坚韧又有些固执，对星空有着近乎执念的热爱；同伴观测员岚则擅长数据分析，冷静而可靠，两人互补的关系是剧情推进的重要动力。",
          "反派阵营的旧日观测员并非单纯的恶，其理念与主角形成鲜明对照，让整部作品的冲突更具张力。",
        ],
      },
      {
        id: "s3",
        heading: "制作看点",
        paragraphs: [
          "本作的星空作画广受好评，制作组大量参考真实天文影像，让星座与星云呈现出可信的光感。",
          "音乐同样出色，主题曲与插入曲在关键情节处的运用被认为是全片加分项。",
        ],
      },
    ],
  },
  {
    id: "work-2",
    type: "work",
    title: "樱花武斗",
    summary:
      "以校园剑道社为舞台的热血漫画，主角在一次次对决中打碎自我的界限。扎实的武打分镜与成长的痛感让它成为长篇连载中的口碑之作。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20determined%20girl%20holding%20a%20wooden%20sword%20surrounded%20by%20falling%20cherry%20blossoms%2C%20dynamic%20action%20pose%2C%20pink%20and%20blue%20tones%2C%20vertical%20manga%20cover&width=600&height=800&seq=work-02&orientation=portrait",
    category: "热血",
    tags: ["樱花武斗", "剑道", "成长", "热血"],
    date: "2021-03-02",
    author: "作画：藤井凉",
    popularity: 88,
    format: "漫画",
    region: "日本",
    year: "2021",
    rating: 8.8,
    sections: [
      {
        id: "s1",
        heading: "剧情简介",
        paragraphs: [
          "《樱花武斗》以校园剑道社为舞台，主角在经历失败与自我怀疑后重新握剑，向着更高的目标一步步迈进。",
          "作品没有夸张的异能设定，而是把重心放在真实的对抗与心理博弈上，让每一场胜负都有分量。",
        ],
      },
      {
        id: "s2",
        heading: "分镜与演出",
        paragraphs: [
          "作者的武打分镜以节奏感见长，出招、格挡、破绽的铺垫清晰可读，读者能直观感受到攻防的流转。",
          "关键对决时常使用大跨页呈现，形成强烈的视觉冲击。",
        ],
      },
      {
        id: "s3",
        heading: "角色群像",
        paragraphs: [
          "除了主角，社团中的每一位成员都有各自的动机与困境，配角塑造相当丰满。",
          "对手阵营同样被认真对待，他们的坚持让主角的成长显得更有说服力。",
        ],
      },
    ],
  },
  {
    id: "work-3",
    type: "work",
    title: "深海夜航",
    summary:
      "一艘潜入无人海域的科考潜艇，一群各怀心事的船员。作品以密闭空间营造压迫感，在悬疑推进中探讨孤独与信任。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20submarine%20diving%20into%20dark%20deep%20ocean%20with%20bioluminescent%20creatures%2C%20moody%20teal%20and%20navy%20palette%2C%20suspenseful%20vertical%20key%20visual&width=600&height=800&seq=work-03&orientation=portrait",
    category: "悬疑冒险",
    tags: ["深海夜航", "悬疑", "冒险", "剧场版"],
    date: "2023-11-20",
    author: "监督：海边渚",
    popularity: 92,
    format: "动画",
    region: "日本",
    year: "2023",
    rating: 9.3,
    sections: [
      {
        id: "s1",
        heading: "剧情简介",
        paragraphs: [
          "《深海夜航》讲述一艘科考潜艇深入无人海域执行任务，随着海面信号断绝，船员们隐藏的秘密逐渐浮现。",
          "作品把大部分篇幅放在密闭的潜艇内部，用有限的场景营造出持续的压迫感。",
        ],
      },
      {
        id: "s2",
        heading: "悬疑设计",
        paragraphs: [
          "剧情的悬念铺陈克制而精准，每一条线索都在前文埋下伏笔，回收时层层递进。",
          "深海环境本身也被塑造成一个角色，黑暗中若隐若现的生物荧光既是奇观也是威胁。",
        ],
      },
      {
        id: "s3",
        heading: "主题表达",
        paragraphs: [
          "在悬疑的外壳之下，作品真正探讨的是孤独与信任——当无人见证时，人是否仍愿意相信彼此。",
          "结尾的处理留给观众充分回味空间，不同解读都能自圆其说。",
        ],
      },
    ],
  },
  {
    id: "work-4",
    type: "work",
    title: "机甲纪元",
    summary:
      "当战争不再由人亲自上阵，机师与座机之间形成了奇特的羁绊。硬核机设与群像叙事并重的科幻动画。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20giant%20robot%20mecha%20with%20a%20pilot%20silhouette%2C%20dramatic%20blue%20lighting%20with%20orange%20glow%2C%20industrial%20sci-fi%20vertical%20key%20visual&width=600&height=800&seq=work-04&orientation=portrait",
    category: "科幻",
    tags: ["机甲纪元", "机甲", "战争", "科幻"],
    date: "2025-01-10",
    author: "机设：南云陆",
    popularity: 89,
    format: "动画",
    region: "日本",
    year: "2025",
    rating: 8.9,
    sections: [
      {
        id: "s1",
        heading: "剧情简介",
        paragraphs: [
          "《机甲纪元》设定在一个战争由机甲代为进行的时代，年轻的机师们被推上战场，却逐渐意识到自己也是棋盘上的棋子。",
          "作品在激烈的战斗之外，着力描写机师与座机之间近乎伙伴的关系，让冰冷的机械有了温度。",
        ],
      },
      {
        id: "s2",
        heading: "机甲设定",
        paragraphs: [
          "本作的机甲设计强调工业感与实用主义，每台座机的结构都经得起推敲，动作中也尊重自身的重量与惯性。",
          "不同阵营的机体在轮廓与配色上差异鲜明，便于观众快速辨认。",
        ],
      },
      {
        id: "s3",
        heading: "群像叙事",
        paragraphs: [
          "作品采用群像视角，多位机师的立场互相碰撞，没有人是纯粹的工具人。",
          "正是这些理念的冲突，让战斗有了超越胜负的意义。",
        ],
      },
    ],
  },
  {
    id: "work-5",
    type: "work",
    title: "幻境牧场",
    summary:
      "一部让人放下心来的治愈系动画。四季流转的牧场、准时响起的开饭铃，平凡日常里藏着最安稳的力量。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20cozy%20countryside%20ranch%20at%20golden%20hour%20with%20green%20hills%20and%20a%20small%20farmhouse%2C%20warm%20healing%20pastel%20tones%2C%20vertical%20illustration&width=600&height=800&seq=work-05&orientation=portrait",
    category: "治愈日常",
    tags: ["幻境牧场", "治愈", "日常", "田园"],
    date: "2022-04-05",
    author: "监督：田野悠",
    popularity: 80,
    format: "动画",
    region: "日本",
    year: "2022",
    rating: 8.5,
    sections: [
      {
        id: "s1",
        heading: "剧情简介",
        paragraphs: [
          "《幻境牧场》围绕一座四季分明的牧场展开，讲述一家人在日复一日的劳作与相处中彼此支撑的故事。",
          "作品几乎没有激烈的冲突，却用细水长流的日常打动了大量观众。",
        ],
      },
      {
        id: "s2",
        heading: "氛围营造",
        paragraphs: [
          "清新的美术与舒缓的配乐共同构筑出治愈氛围，每一集都像一次短暂的休憩。",
          "食物与季节的描绘尤其用心，隔着屏幕也能感受到温度。",
        ],
      },
      {
        id: "s3",
        heading: "适合人群",
        paragraphs: [
          "如果你偏爱安静温暖的叙事，或想在忙碌之余寻找片刻放松，这部作品值得一看。",
          "它不追求戏剧性的起伏，却能让人在结束一天后感到安心。",
        ],
      },
    ],
  },
  {
    id: "work-6",
    type: "work",
    title: "夜行侦探社",
    summary:
      "只在夜里营业的侦探社，接手的都是白天无人愿意触碰的委托。冷峻的都市氛围与缜密的推理结构并重。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20detective%20in%20a%20rainy%20neon%20city%20at%20night%2C%20wet%20reflective%20streets%2C%20deep%20blue%20with%20warm%20accents%2C%20noir%20vertical%20key%20visual&width=600&height=800&seq=work-06&orientation=portrait",
    category: "悬疑推理",
    tags: ["夜行侦探社", "推理", "都市", "悬疑"],
    date: "2024-10-01",
    author: "原案：冬月凪",
    popularity: 90,
    format: "动画",
    region: "日本",
    year: "2024",
    rating: 9.0,
    sections: [
      {
        id: "s1",
        heading: "剧情简介",
        paragraphs: [
          "《夜行侦探社》的主角经营着一家只在夜间营业的侦探社，接手的都是别人不愿碰的棘手委托。",
          "故事以单元案件串联主线，每桩委托背后都藏着与主角自身相关的线索。",
        ],
      },
      {
        id: "s2",
        heading: "推理结构",
        paragraphs: [
          "作品的推理设计相当严谨，关键线索都会在揭晓前公平地呈现给观众，留给观众自行推演的空间。",
          "反转虽有，但大多建立在合理铺垫之上，而非为惊而惊。",
        ],
      },
      {
        id: "s3",
        heading: "氛围与美术",
        paragraphs: [
          "雨夜都市的作画极具质感，霓虹倒影与潮湿街道共同营造出冷峻又迷人的气氛。",
          "色彩运用克制，冷暖对比鲜明，与剧情基调高度契合。",
        ],
      },
    ],
  },
  {
    id: "work-7",
    type: "work",
    title: "光界旅人",
    summary:
      "在光与影的交界处旅行，每一重光界都有独立的规则。原创奇幻动画，用美术语言展开一场关于选择的旅程。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20traveler%20walking%20on%20a%20glowing%20path%20between%20surreal%20worlds%20of%20light%2C%20warm%20amber%20and%20deep%20blue%2C%20vertical%20fantasy%20key%20visual&width=600&height=800&seq=work-07&orientation=portrait",
    category: "奇幻",
    tags: ["光界旅人", "奇幻", "原创", "旅程"],
    date: "2026-01-08",
    author: "监督：白川遥",
    popularity: 87,
    format: "动画",
    region: "日本",
    year: "2026",
    rating: 8.7,
    sections: [
      {
        id: "s1",
        heading: "剧情简介",
        paragraphs: [
          "《光界旅人》的主角是一位穿越不同光界的旅人，每抵达一重光界，都要面对一道关于选择的考验。",
          "作品以旅途为线索，串联起风格各异的独立篇章，整体气质诗意而克制。",
        ],
      },
      {
        id: "s2",
        heading: "世界观",
        paragraphs: [
          "光界的设定不依赖繁复的专有名词，而是通过光的明暗、质地与运动来呈现规则。",
          "每一重光界都拥有独立的美术语言，让观众在视觉上始终保持新鲜感。",
        ],
      },
      {
        id: "s3",
        heading: "主题与看点",
        paragraphs: [
          "旅途的真正主题是“选择”——当无法两全时，人如何决定自己要走的路。",
          "原创企划在制作上颇为大胆，是近年值得关注的奇幻新作。",
        ],
      },
    ],
  },
  {
    id: "work-8",
    type: "work",
    title: "魔法装订社",
    summary:
      "在一个书会说话的世界里，装订社负责修复被遗忘的故事。魔法、工艺与温情交织的奇幻漫画。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20magical%20library%20with%20floating%20books%20and%20glowing%20runes%2C%20warm%20amber%20and%20deep%20blue%20lighting%2C%20vertical%20fantasy%20cover&width=600&height=800&seq=work-08&orientation=portrait",
    category: "奇幻",
    tags: ["魔法装订社", "奇幻", "工艺", "成长"],
    date: "2023-06-12",
    author: "作画：月见里",
    popularity: 82,
    format: "漫画",
    region: "日本",
    year: "2023",
    rating: 8.6,
    sections: [
      {
        id: "s1",
        heading: "剧情简介",
        paragraphs: [
          "在《魔法装订社》的世界里，书会被赋予生命，而装订社的职责就是修复那些被遗忘、被损坏的故事。",
          "主角作为年轻学徒，在一次次修复委托中逐渐理解“故事为何值得被保存”。",
        ],
      },
      {
        id: "s2",
        heading: "设定亮点",
        paragraphs: [
          "作品把“装订”这一工艺与魔法巧妙结合，每一道工序都对应着具体的魔法规则，细节考究。",
          "不同书籍拥有各自的性格，与主角的互动妙趣横生。",
        ],
      },
      {
        id: "s3",
        heading: "情感内核",
        paragraphs: [
          "看似轻松的奇幻故事，背后始终贯穿着对“记忆”与“传承”的温柔思考。",
          "读完每一话，往往会留下一丝安静的感动。",
        ],
      },
    ],
  },
  {
    id: "work-9",
    type: "work",
    title: "银河列车",
    summary:
      "载着旅人驶向未知的星际列车，每一站都是一段人生。跨越时代的经典之作，如今以高清形式重制回归。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20classic%20space%20train%20traveling%20through%20a%20starfield%2C%20nostalgic%20retro%20animation%20aesthetic%2C%20deep%20blue%20cosmos%20with%20warm%20golden%20lights%2C%20vertical&width=600&height=800&seq=work-09&orientation=portrait",
    category: "经典",
    tags: ["银河列车", "经典", "宇宙", "旅程"],
    date: "1998-05-20",
    author: "原作：星野列",
    popularity: 85,
    format: "动画",
    region: "日本",
    year: "1998",
    rating: 9.2,
    sections: [
      {
        id: "s1",
        heading: "剧情简介",
        paragraphs: [
          "《银河列车》讲述一班载着旅人驶向未知的星际列车，乘客们各自背负着过去，在旅途中寻找属于自己的终点。",
          "作品以单元形式展开，每一站都是一段完整的人生故事。",
        ],
      },
      {
        id: "s2",
        heading: "经典地位",
        paragraphs: [
          "作为跨越时代的经典，本作影响了此后大量以“旅途”为主题的动画创作。",
          "其克制的叙事与留白式的结尾，至今仍被观众反复讨论。",
        ],
      },
      {
        id: "s3",
        heading: "重制看点",
        paragraphs: [
          "本次高清重制保留原作手绘质感，同时修复了画面划痕与色彩偏移，让光影更为通透。",
          "对老观众而言是一次温柔的重逢，对新观众则是认识经典的绝佳入口。",
        ],
      },
    ],
  },
  {
    id: "work-10",
    type: "work",
    title: "风与纸鸢",
    summary:
      "一只纸鸢连接起离别与重逢。独立动画短片以极简叙事与诗意画面，讲了一个关于牵挂的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20paper%20kite%20flying%20high%20in%20a%20wide%20open%20sky%20above%20rolling%20fields%2C%20gentle%20blue%20and%20cream%20palette%2C%20artistic%20vertical%20illustration&width=600&height=800&seq=work-10&orientation=portrait",
    category: "文艺",
    tags: ["风与纸鸢", "文艺", "短片", "独立动画"],
    date: "2026-09-21",
    author: "导演：林一舟",
    popularity: 74,
    format: "动画",
    region: "中国",
    year: "2026",
    rating: 8.4,
    sections: [
      {
        id: "s1",
        heading: "剧情简介",
        paragraphs: [
          "《风与纸鸢》以一只纸鸢为线索，讲述一段关于离别与重逢的记忆，全片几乎没有对白，靠画面与音乐完成叙事。",
          "纸鸢被赋予象征意义，代表人与人之间若即若离的牵挂。",
        ],
      },
      {
        id: "s2",
        heading: "创作特色",
        paragraphs: [
          "短片由个人创作者独立完成，历时近两年，从分镜到上色均由一人负责，风格统一而真诚。",
          "画面大量运用留白与风的表现，让情绪在静默中流动。",
        ],
      },
      {
        id: "s3",
        heading: "获奖与评价",
        paragraphs: [
          "作品在国际动画节中获得评审团特别奖，评审称赞其以极简手法传达细腻情感。",
          "不少观众表示，短片结束后仍久久沉浸在那种淡淡的怀念里。",
        ],
      },
    ],
  },
  {
    id: "work-11",
    type: "work",
    title: "苍蓝剑客",
    summary:
      "江湖、剑与道义。国产武侠漫画以写意的笔触描绘一位游侠在乱世中的抉择与坚守。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20wandering%20swordsman%20in%20traditional%20eastern%20robe%20under%20a%20pale%20moon%2C%20ink%20wash%20style%2C%20deep%20blue%20and%20jade%20tones%2C%20vertical%20illustration&width=600&height=800&seq=work-11&orientation=portrait",
    category: "武侠",
    tags: ["苍蓝剑客", "武侠", "国漫", "江湖"],
    date: "2020-08-18",
    author: "作画：青崖",
    popularity: 79,
    format: "漫画",
    region: "中国",
    year: "2020",
    rating: 8.3,
    sections: [
      {
        id: "s1",
        heading: "剧情简介",
        paragraphs: [
          "《苍蓝剑客》以乱世江湖为背景，讲述一位游侠在道义与生存之间反复抉择的故事。",
          "作品不以爽快的复仇为主线，而更关注人物在时代洪流中的坚守与妥协。",
        ],
      },
      {
        id: "s2",
        heading: "美术风格",
        paragraphs: [
          "作画借鉴水墨写意的手法，留白与皴擦并用，营造出独特的东方武侠意境。",
          "打斗场面强调写意与留白，冲淡了血腥感，反而更具张力。",
        ],
      },
      {
        id: "s3",
        heading: "主题表达",
        paragraphs: [
          "作品反复追问一个问题：当坚持会伤害他人时，是否仍要坚守？",
          "正因没有简单答案，主角的每一次选择都格外沉重。",
        ],
      },
    ],
  },
  {
    id: "work-12",
    type: "work",
    title: "玻璃海之约",
    summary:
      "在只能于夏天出现的海边小镇，两个少年许下了一个关于未来的约定。青春、透明感与一丝苦涩并存的动画。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20poster%20of%20two%20teenagers%20standing%20on%20a%20sunlit%20seaside%20town%20street%2C%20blue%20sky%20and%20sparkling%20sea%2C%20nostalgic%20summer%20anime%20style%2C%20vertical%20key%20visual&width=600&height=800&seq=work-12&orientation=portrait",
    category: "青春",
    tags: ["玻璃海之约", "青春", "夏日", "治愈"],
    date: "2025-07-19",
    author: "监督：夏川澄",
    popularity: 86,
    format: "动画",
    region: "日本",
    year: "2025",
    rating: 8.9,
    sections: [
      {
        id: "s1",
        heading: "剧情简介",
        paragraphs: [
          "《玻璃海之约》的故事发生在一个只在夏天才会短暂出现的海边小镇，两位少年在这里相遇，并许下关于未来的约定。",
          "青春期的犹豫、悸动与告别，被包裹在透明感十足的画面之中。",
        ],
      },
      {
        id: "s2",
        heading: "视听风格",
        paragraphs: [
          "作品的光影处理极为讲究，天空与海面的反光营造出通透的夏日氛围。",
          "配乐以钢琴与弦乐为主，克制的旋律精准地贴合了人物的情绪起伏。",
        ],
      },
      {
        id: "s3",
        heading: "情感表达",
        paragraphs: [
          "作品并不回避成长中的遗憾，正因如此，那份约定才显得格外珍贵。",
          "结尾处理含蓄而有余韵，是青春题材中难得的成熟之作。",
        ],
      },
    ],
  },
];